const env = 'https://ke6ub3y4o8.execute-api.us-east-1.amazonaws.com/v1/bff';
const paymentus = 'https://ipn2.paymentus.com';
const paymentus1 = 'https://ipn.paymentus.com';

export const environment = {
  siteKey: `6LfrR6UtAAAAAN6x0cnC6ZZ3noyRaCPSIBxj0f11`,
  production: true,
  env: 'prod',
  backend_server_url: env,
  backend_server_url_auth: `${env}/auth/oauth/token`,
  backend_server_url_account: `${env}/b2c-account-api`,
  backend_server_url_identity: `${env}/identity-api/users`,
  backend_server_url_identity_guest: `${env}/identity-api/guest/users`,
  backend_server_url_identity_2: `${env}/identity-api`,
  backend_server_url_policy: `${env}/personal-policy-api`,
  backend_server_url_billing: `${env}/billing-api`,
  backend_server_url_claims: `${env}/claims-livo`,
  paymentus_account: `${paymentus}/cp/mapf/make-payment-express?authToken=`,
  paymentus_guest: `${paymentus}/rotp/mapf?itok=`,
  paymentus_wallet: `${paymentus}/cp/mapf/my-wallet?authToken=`,
  paymentus_add_card_to_profile: `${paymentus1}/xotp/pm/matw?authToken=`,
  paybill_link: `https://paybill.com/v2/CommerceInsuranceCWEBinstallment/login.aspx`,
  paybill_tw: `https://www.paybill.com/V2/mapfreinsuranceb2c/Login.aspx`,
  paybill_base_url: `https://paybill.com/`,
  guest_paybill: `https://paybill.com/CommerceInsuranceInstallments`,
  loginOld: `https://www.mapfreinsurance.com/b2cwebapp/account/loginView?state=MA`,
  registerOld: `https://www.mapfreinsurance.com/b2cwebapp/view/account?state=MA`,
  claim_doc_url: `https://claims.mapfreinsurance.com/documents/emailClaimDocuments`,
  claim_doc_url_acmic: `https://claims.insure.wa.aaa.com/documents/emailClaimDocuments`,
  make_payment_url_acmic: `https://myaccount.insure.wa.aaa.com/make-payment`,
  make_payment_url: `https://payments.mapfreinsurance.com/`,
  claim_url_acmic: `https://mcr.insure.wa.aaa.com/claims`,
  claim_url: `https://mcr.mapfreinsurance.com/claims/#/ReportClaim`,
  paybill_link_app: `https://www.paybill.com/CommerceInsuranceInstallments`,
  ui_url: 'https://myaccount.mapfreinsurance.com',
  bio_url: 'mapfreusa.com',
  legacy_login: 'https://www.mapfreinsurance.com/b2cwebapp/account/login',
  dTMapfreScript: 'https://js-cdn.dynatrace.com/jstag/147f84b2bdc/bf87442dlk/aa10917873d47df4_complete.js',
  dTAcmicScript: 'https://js-cdn.dynatrace.com/jstag/147f84b2bdc/bf87442dlk/7507b6509be6cd70_complete.js',
  adobeScript: 'https://assets.adobedtm.com/5de54b409272/e32ffcc056cf/launch-e8f6a50c6ad5.min.js',
  oneIncScript:"https://portalone.processonepayments.com/GenericModalV2/PortalOne.js",
  OKTA: {
    MAPFRE: {
      ISSUER: "https://mysignin.mapfreinsurance.com",
      CLIENT_ID: "0oa1ytu7b3gW9hBfW1d8",
      MOBILE_CLIENT_ID: '0oa1z375kbcv9kSSh1d8',
    },
    AAA: {
      ISSUER: "https://mysignin.insure.wa.aaa.com",
      CLIENT_ID: "0oa1ytu7prixlm4iy1d8",
    }
  }
};
